import { useState } from 'react';
import { EnteteEcran } from '../components/ui/Primitives';
import { ApprenantTimeline } from '../components/dossier/ApprenantTimeline';

const FILTRES = ['Toutes', 'Accompagnement', 'Handicap', 'Aménagement', 'Refus', 'Dossier'] as const;

export function AppTimelinePage(): JSX.Element {
  const [filtre, setFiltre] = useState<string>(FILTRES[0]);

  return (
    <div className="mx-auto max-w-[1500px] space-y-6 p-4 sm:p-6">
      <EnteteEcran
        titre="Frise de mon dossier"
        sousTitre="Espace apprenant · accompagnement, handicap, aménagements d’examen et refus"
      />

      <div className="flex flex-wrap gap-2">
        {FILTRES.map((libelle) => (
          <button
            key={libelle}
            type="button"
            aria-pressed={filtre === libelle}
            onClick={() => setFiltre(libelle)}
            className={`rounded-xl px-3 py-1.5 text-xs font-semibold transition [@media(pointer:coarse)]:min-h-[40px] ${
              filtre === libelle
                ? 'bg-codialis-navy text-white'
                : 'border border-gray-200 bg-white text-codialis-gray hover:bg-gray-50'
            }`}
          >
            {libelle}
          </button>
        ))}
      </div>

      <div className="rounded-2xl bg-white p-4 sm:p-6 shadow-card lg:p-8">
        <ApprenantTimeline filtre={filtre} />
      </div>
    </div>
  );
}
